import React, { createContext, useCallback, useContext, useState } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./NotificationTemplateUIHelpers";

const NotificationTemplateUIContext = createContext();

export function useNotificationTemplateUIContext() {
  return useContext(NotificationTemplateUIContext);
}

export const NotificationTemplateUIConsumer =
  NotificationTemplateUIContext.Consumer;

export function NotificationTemplateUIProvider({
  notificationTemplateUIEvents,
  children
}) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback(nextQueryParams => {
    setQueryParamsBase(prevQueryParams => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const initNotificationTemplate = {
    name: ""
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    initNotificationTemplate,
    newNotificationTemplateButtonClick:
      notificationTemplateUIEvents.newNotificationTemplateButtonClick,
    openEditNotificationTemplatePage:
      notificationTemplateUIEvents.openEditNotificationTemplatePage,
    openNotificationTemplateFilePage:
      notificationTemplateUIEvents.openNotificationTemplateFilePage
  };

  return (
    <NotificationTemplateUIContext.Provider value={value}>
      {children}
    </NotificationTemplateUIContext.Provider>
  );
}
